<div class="quick-link-section">
  <div class="row quick-link-row">
    <div class="col-12 custom-col-padding">
      <h2>Useful links</h2>
    </div>
  </div>
  <div class="row quick-link-row">
    @for (quickLink of quickLinks; track quickLink) {
      <div
        class="col-12 col-sm-6 col-lg-4 quick-link-col custom-col-padding"
        >
        <common-quick-link
          [label]="quickLink.label"
          [quickLinkId]="quickLink.id"
          [url]="quickLink.url"
          [leftIcon]="quickLink.leftIcon"
          [rightIcon]="quickLink.rightIcon"
          (linkSelected)="selectedQuickLink($event)"
          >
        </common-quick-link>
      </div>
    }
  </div>
</div>
